export const env = {
  base_api_url: process.env.REACT_APP_API_URL,
  api_url: `${process.env.REACT_APP_API_URL}/api/v1`,
  api_url_landing: `${process.env.REACT_APP_API_URL}/landing/v1/public/api`,
  api_url_auth: `${process.env.REACT_APP_API_URL}/auth/v1/public/`
}
export const AUTH_SERVICES = {
  login: `/auth/login-cms`,
  logout: `/auth/logout`,
  refreshToken: `auth/refresh-token`,
  permission: `/permission`
}
export const F18_SERVICES = {
  department: `/department`,
  permission: `/permission`,
  user: `/user`,
  pakages: `/pakages`,
  services: `/partner`,
  postSearch: `post/internal`,
  postAction: `post`,
  // post: `/post/add`,
  address: `/address`,
  changePassword: `/change-password`,
  upload: '/upload',
  projects: `/project-library`,
  projectRecommend: `/project-recommend`,
  notification: '/notification/manager',
  addMoney: `payment/addmoney-cms`,
  uploadImgPrivate: `/upload/upload-cccd`
}
